import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ElementRef, Renderer2 } from '@angular/core';
import { DataSet } from 'vis-data';
import { Timeline, DataSetDataGroup } from 'vis-timeline';
import { AllergyService, DocumentService, GlobalSettingsService, ImageService, LabsService, MedicationService, OrderService, ProblemService, VisitsService, VitalService } from '../api/services';
import { Subject, combineLatest, combineLatestAll, map, merge, mergeMap, observable, of, switchMap, tap, timeoutWith, zip } from 'rxjs';
import * as moment from 'moment';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Overlay } from 'primeng/overlay';
import { icons } from './icons';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SelectedPatientService } from '../carefinity/views/patient/patient-list/patient-service';
import { CareFinitySession } from '../carefinity/services/CareFinitySession';
import { Image, ImageModels, Lab } from '../api/models';
@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrl: './timeline.component.css'
})
export class TimelineComponent {
    icons = icons;
    groupsMappings: { id: number; content: string; }[];
    timeline: Timeline;
    options: any = {};
    data: any;
    groups: any;

    @ViewChild('timeline', { static: true }) timelineContainer: ElementRef;
    overlayVisible = false;


    @ViewChild("overlayContent")
    overlayComponent: Overlay;


    eventsGroupedByDates = {}
    clusterMapping: any = {};
    fieldsToDisplayinDetailView: any[];
    selectedEvent: any = {};
    selectedRow
    selectedGroup: any={};
    summaryViewData: { date: string; }[];
    eventsOnSelectedDate: any;
    summaryViewColumns = [];
    categories: Lab[]=[];
    testName: string;
    arrlabdetails: any;
    cols: any[];
    HeaderCol: any;
    LinkStyle: string;

    firstSelectedElement = new Subject<Lab>
    allCategories: Lab[]=[];
    pdf: Blob;
    showPrintButton: boolean;
    preferences = {}
    configuration = {

    
    "Problems": {
        date: "shortVisitDate", desc: "problemDescription", itemsToDisplay: [
            { key: 'onSetDate', label: 'Onset Date' },
            { key: 'diagnosisCodeID', label: 'Code' },
            { key: 'problemDescription', label: 'Condition' },
            { key: 'statusDescription', label: 'Status' },
            { key: 'diagnosedDate', label: 'Diagnosed Date' },
            { key: 'isResolved', label: 'Resolved' },],
        order: 1, enable: CareFinitySession.user.roles.problems
    },
    "Vitals": {
        date: "date", desc: "", itemsToDisplay: [

            { key: 'height', label: 'Height' },
            { key: 'weight', label: 'Weight' },
            { key: 'bmi', label: 'BMI' },
            { key: 'bp', label: 'BP' },
            { key: 'pulse', label: 'Pulse' },
            { key: 'temp', label: 'Temp' },
            { key: 'resp', label: 'Resps' },
            { key: 'spo2', label: 'SpO2' },
            { key: 'headCirc', label: 'Head Circ' },
        ], order: 9, enable: CareFinitySession.user.roles.vitals
    },
    "Allergies": {
        date: "shortVisitDate", desc: "allergyReaction", itemsToDisplay: [
            { key: 'onSetDate', label: 'Onset Date' },
            { key: 'resolvedDate', label: 'Resolved Date' },
            { key: 'allergyDescription', label: 'Ingredient/Allergen' },
            { key: 'comment', label: 'Brand Name' },
            { key: 'allergyReaction', label: 'Reaction' },
            { key: 'providerName', label: 'Provider' },
        ],
        order: 2, enable: CareFinitySession.user.roles.allergies
    },
    "Visits": {
        date: "shortVisitDate", desc: "visitType", itemsToDisplay: [

            { key: 'visitType', label: 'Visit Type' },
            { key: 'appointmentDetails', label: 'Detail' },
            { key: 'renderingProvider', label: 'Seen By' },
            { key: 'location', label: 'Location' },

        ], order: 4, enable: CareFinitySession.user.roles.visits
    },
    //Orders: { date: "orderDate", desc: "description" },
    "Medications": {
        date: "shortStartDate", desc: "brandDoseForm", itemsToDisplay: [
            { key: 'brandDoseForm', label: 'Medication-Dose' },
            { key: 'rxQuanity', label: 'Qty' },
            { key: 'rxRefills', label: 'Refills' },
            { key: 'shortDateStopped', label: 'Stop Date' },
            { key: 'providerName', label: 'Entered By' },], order: 3, enable: CareFinitySession.user.roles.medication 
    },
    "Labs": {
        date: "orderDate", desc: "testDescription", itemsToDisplay: [
            {
                label: "Description", key: "testDescription"
            }], order: 5, enable: CareFinitySession.user.roles.labs
    }, "Orders": {
        date: "orderedDate", desc: "testDescription", itemsToDisplay: [
            { key: 'class', label: 'Order Type' },
            { key: 'description', label: 'Description' },
            { key: 'status', label: 'Status' },
            { key: 'orderedBy', label: 'Entered By' }], order: 6, enable: CareFinitySession.user.roles.orders
    },

        "Documents": {
            date: "visitDate", desc: 'description', order: 7, enable: CareFinitySession.user.roles.documents && CareFinitySession.practiceSettings.showPatientDocuments
    },
        "Images": {
            date: "createdOn", desc: 'description', order: 8, enable: CareFinitySession.user.roles.images &&  CareFinitySession.practiceSettings.showPatientImage


    }
    }
    enabledDocumentDownloads: boolean;
    constructor(
        private problemsService: ProblemService,
        private vitalsService: VitalService,
        private allergiesService: AllergyService,
        private visitsService: VisitsService,
        private ordersService: OrderService,
        private labsService: LabsService,
        private medicationService: MedicationService,
        private docservice: DocumentService,
        private router: Router,
        private messageService: MessageService,
        private selectedPatientService: SelectedPatientService,
        private imageService: ImageService,
        private activatedRoute: ActivatedRoute,
        private globalSettingsService: GlobalSettingsService
    ) {

        this.preferences = this.activatedRoute.snapshot.data.preferences;
        this.getOptions(this.preferences);

    }

    ngOnInit() {




        this.firstSelectedElement.subscribe(lab => this.Setlabitem(lab))
        const payload = {
            patientId: sessionStorage.getItem('ptId'),
            emrpracticeId: localStorage.getItem('EmrPracticeId'),
        }


        if (CareFinitySession.user.roles.labs) {
            this.labsService.labsGetDistinctTest(payload).subscribe(data => {

                this.allCategories = data;

            })
        }


        let observables:any = {

            Problems: this.problemsService.problemList(payload),
            Vitals: this.vitalsService.vitalList(payload),
            Allergies: this.allergiesService.allergyList(payload),
            Visits: this.visitsService.visitsList(payload),
            Orders: this.ordersService.orderList(payload),
            Medications: this.medicationService.medicationList(payload),
            Labs: this.labsService.labsAllTests(payload).pipe(

                map(i => {


                    var labs = i.map(k => JSON.parse(k));
                    console.log("labs data is ", labs)
                    return flattenArray( labs);

                })

            )
               ,
            Documents: this.docservice
                .documentList({
                    patientId: sessionStorage.getItem('ptId'),
                    emrpracticeId: localStorage.getItem('EmrPracticeId'),
                    pageNumber: 1,
                    searchText: ""
                }),
                
            Images: this.imageService.imageGetcategorylistbypatient(payload).pipe(switchMap(i => {


                return combineLatest(i.map(k => {

                   return  this.imageService.imageList({
                        category: k.categoryId,
                        ...payload,
                        pageNumber: 1,
                        NumberOfRecords: 1000000

                   }).pipe(map(d=>d.data))

              })
              )

            })).pipe(map(d => flattenArray(d)), map(d => ({data:d})))

        }

        
            const renamedConfig = {}
            const renamedObservables = {}

    


    
        //observables = Object.fromEntries(
        //    Object.entries(preferences).map(([key, value]) => [preferences[key] || key, value])
        //  );

        //  this.configuration = Object.fromEntries(
        //    Object.entries(preferences).map(([key, value]) => [preferences[key] || key, value])
        //  );

        let filterdObservables=Object.keys(observables).filter(i => this.configuration[i].enable).reduce((res, key) => Object.assign(res, { [key]: observables[key] }), {});
        combineLatest(filterdObservables).subscribe(data => {
            this.getTimelineGroups(data);
            let d = this.getTimelineData(data).filter(i => !!i.start);

            let startDate = new Date();
            let endDate = new Date()
            if (d.length > 0) {
                startDate = d.map(i => i.start.getTime())?.reduce((currMin, nextMin) => Math.min(currMin, nextMin))
                endDate = d.map(i => i.start.getTime())?.reduce((currMin, nextMin) => Math.max(currMin, nextMin))
            }
            this.options.start = new Date(startDate);
            this.options.end = new Date(endDate);
            this.data = new DataSet(d);

            this.timeline = new Timeline(this.timelineContainer.nativeElement, null, this.options);
            this.timeline.setGroups(this.groups);
            this.timeline.setItems(this.data);
            this.timeline.fit();

            this.timeline.on('click', (event) => {
                console.log("event is ", event)
                this.fieldsToDisplayinDetailView = [];

                if (event.item) {
                    // Check if the clicked item is a cluster
                    const clusterId = event.item;

                    let items=[]
                    if (event.isCluster) {

                        // Get the IDs of the items in the clicked cluster
                        items = this.clusterMapping[clusterId]


                         }
                    else {

                        items = [this.data.get().find(i => i.id == event.item)];
                    }

                    console.log('Items in cluster:', items);
                    this.selectedGroup = this.groupsMappings.find(i => i.id === event.group)

                    if (this.selectedGroup.content === 'Labs') {
                        //handle special case for labs
                        this.summaryViewData = items.map(i => i.item);
                        this.categories = this.getCategories();
                        this.selectEvent(this.categories[0])
                        this.overlayVisible = true;

                        return;
                    }


                    if (this.selectedGroup.content === 'Documents') {
                        this.summaryViewColumns = [{ label: 'Date', key: 'visitDate',type:'date' }, { label: 'Description', key: 'description' }]
                        this.summaryViewData = items.map(i => i.item).reverse();
                        


                    }


                    else if (this.selectedGroup.content === 'Images') {
                        this.summaryViewColumns = [{ label: 'Date', key: 'createdOn', type: 'string' }, { label: 'Description', key: 'description' }]
                        this.summaryViewData = items.map(i => i.item).reverse();



                    }
                    else {
                        this.eventsGroupedByDates = groupBy(items, (i: any) => i.start)
                        this.summaryViewColumns = [{ label: 'Date', key: 'date', type: 'date' }]
                        this.summaryViewData = Object.keys(this.eventsGroupedByDates).map(i => ({ "date": i, "key": this.selectedGroup.content })).reverse()


                    }

                    if (this.summaryViewData.length > 0) {
                        this.selectedEvent = this.summaryViewData[0];
                        this.selectEvent(this.selectedEvent)
                    }

                   
                    this.overlayVisible = true;


                }
            });


            // Listen for cluster events to track items in clusters



      



    })
    }

    getTimelineGroups(data) {
        // create groups

        this.groupsMappings = Object.keys(data).map((i, index) => {
            return { id: index, content: i, order: this.configuration[i].order }

        }); 
        this.groups = new DataSet(this.groupsMappings);


    }

    getTimelineData(data) {

        console.log("my data is ",data)

        let d = []
        let groupIndex = 0;
        let idForItems = 0
        
        for (let k in data) {
            let tranforedData = []
            if (k === "Labs") {

                let labData = data["Labs"].map(i => {

                    let dates = Object.keys(i).map(k => k.split("|")[0])
                    console.log("dates",dates)


                    let d =   dates.map(d => {



                        let m = moment(d.replace(/\s+/g, ' ').trim(), ['YYYY-MM-DD', 'MMM DD YYYY hh:mmA', 'MMM DD YYYY h:mmA' ,'MMM D YYYY hh:mmA', 'MMM D YYYY h:mmA','L'],true);

                        

                        if (m.isValid()) {

                            return {
                                id: idForItems++,
                                group: groupIndex,
                                start: m.isValid() ? m.toDate() : null,
                                desc: this.configuration[k].desc,
                                item: { ...i },
                                key: k
                            };
                        }
                     return null;
                 }).filter(i => !!i)

                    return d;




                    

                })
                console.log("ldapdata is ", labData)
                tranforedData = flattenArray(labData)
                console.log("flatered data is", tranforedData)


            } else { 
                tranforedData = data[k]?.data.map((i, index) => {
                    let m = moment(i[this.configuration[k].date], 'L');
                    if (!m.isValid()) {
                        m = moment(i[this.configuration[k].date], 'YYYY-MM-DD');
                    }
                    return {
                        id: idForItems++,
                        group: groupIndex,
                        start: m.isValid() ? m.toDate() : null,
                        desc: this.configuration[k].desc,
                        item: { ...i },
                        key: k
                    };



                })
        }
            groupIndex++;

            d = [...d, ...tranforedData]

        }
        console.log("d is ",d)

        return d.filter(i => !!i.start);




    }

    getOptions(preferences:any) {
        this.options = {
            stack: false,
            start: new Date(),
            cluster: {
                titleTemplate: "Cluster containing {count} events. Zoom in to see the individual events.",
                showStipes: false,
            },
            end: new Date(),
            margin: {
                item: 20, // minimal margin between items
                axis: 100   // minimal margin between items and the axis
            },

            orientation: 'bottom',
            groupTemplate: (group) => {

                console.log(group)
                return `<strong>${preferences[group.content.toLowerCase()]||group.content}</strong>`
            },
            template: (itemData, element, data) => {


                if (data.isCluster) {

                    const clusterId = data.uiItems[0].cluster.id;
                    this.clusterMapping[clusterId] = data.uiItems.map(i => i.data);
                    return `  <div style="text-align: center;">
<div>${this.icons[data.items[0].key]}</div>
<span style="display: block; margin-top: 5px; font-weight: bold;">${data.items.length}</span>
</div>`;
                } else {
                    return `  <div style="text-align: center;">
<div>${this.icons[data.key]}</div>
<span style="display: block; margin-top: 5px; font-weight: bold;">1</span>
</div>`;
                }
            },
            xss: {
                disabled: true
                /*filterOptions: {
                    whiteList: {
                        i: ["class"],
                        span: ["class"],
                        div: ["style"],
                        svg:[]
                    }
                }*/

            }
        };

    }



    show(event) {

        this.overlayVisible = true
        /* console.log(event.target);
         this.overlayComponent.show(event.target)*/
    }

    selectEvent(event) {

        if (this.selectedGroup.content == 'Documents') {
            this.viewDoc(event)
        }

       else if (this.selectedGroup.content == 'Images') {

            this.viewImage(event)


        }
        else if (this.selectedGroup.content == "Labs" && event) {

            console.log("preselect is",event)
            setTimeout(()=>this.Setlabitem(event),100);
        }
        else {
            this.fieldsToDisplayinDetailView = this.configuration[event.key].itemsToDisplay


            this.eventsOnSelectedDate = this.eventsGroupedByDates[event.date].map(i => i.item)


        }

      



    }
    viewDoc(rowData: any) {
        this.docservice
            .documentDetail({
                Id: rowData.fileName,
                Description: rowData.description,
                DBIndic: rowData.databaseIndic,
                fileFormat: rowData.format,
                DocumentType: rowData.documentType,
                Location: rowData.location,
                VisitDate: rowData.visitDate,
                PracticeId: localStorage.getItem('EmrPracticeId'),
                PatientId: this.selectedPatientService.getPatientValue().patientId,
            }).pipe(timeoutWith(10 * 1000, this.docservice
                .documentDetail({
                    Id: rowData.fileName,
                    Description: rowData.description,
                    DBIndic: rowData.databaseIndic,
                    fileFormat: rowData.format,
                    DocumentType: rowData.documentType,
                    Location: rowData.location,
                    VisitDate: rowData.visitDate,
                    PracticeId: localStorage.getItem('EmrPracticeId'),
                    PatientId: this.selectedPatientService.getPatientValue().patientId,
                })))
            .subscribe(
                (documentDetails) => {
                    this.docservice
                        .documentGetDocuments({
                            fn: documentDetails.docName,
                            PatientName: sessionStorage.getItem('ptName'),
                        })
                        .subscribe(
                            (file) => {
                                if (documentDetails.flexPaper) {
                                    console.log(documentDetails.docName)
                                        
                                          
                                       this.pdf = file;
                                    this.showPrintButton = (CareFinitySession?.user.roles.patientRecordsPrint && CareFinitySession.practiceSettings.enablePatientDemographicPrint) || false;
                                    this.enabledDocumentDownloads = (CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user.roles.enableDocumentDownloads) || false


                                                   
                              
                                } else {
                                    const binaryData = [file]
                                    const downloadLink = document.createElement('a')
                                    downloadLink.href = window.URL.createObjectURL(
                                        new Blob(binaryData, { type: file.type }),
                                    )
                                    downloadLink.target = '_blank'
                                    downloadLink.setAttribute('inline', 'arshid')
                                    document.body.appendChild(downloadLink)
                                    downloadLink.click()
                                    document.body.removeChild(downloadLink) // Clean up
                                }
                            },
                            (err) => {
                                this.pdf = null;
                                this.messageService.add({
                                    key: 'alertToast',
                                    severity: 'error',
                                    summary: 'ERROR',
                                    detail:
                                        'Document File missing, Please Contact Technical Support',
                                })
                            },
                        )

                    console.log(documentDetails)
                },
                (err) => {
                    this.pdf = null;

                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'error',
                        summary: 'ERROR',
                        detail: 'Document File missing, Please Contact Technical Support',
                    })
                },
            )
    } 
    back(){

        this.router.navigate(['Patient/timeline'])
    }


    //copied code from labs
    Setlabitem(lab) {
        this.loadlabList(1, '', lab.testName)

    }

    loadlabList(pageNumber: number, sortbydirection: string, testName: string) {
        debugger
        this.testName = testName

        console.log(testName)

        this.labsService
            .labsList({
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                pageNumber: pageNumber,
                sortbydirection: sortbydirection,
                TestName: testName,
            })
            .subscribe((result) => {
                if (result.length > 0) {
                    var objJson1 = JSON.parse(result)
                    //  console.log(objJson1);
                    debugger
                    this.arrlabdetails = objJson1

                    this.cols = []

                    for (var key in objJson1[0]) {
                        if (this.cols.indexOf(key) === -1) {
                            this.cols.push({ field: key, header: key })
                        }
                    }
                }
            })
    }


    Getheader(item) {
        if (item.indexOf('|') > -1) {
            this.HeaderCol = item.split('|')
            return this.HeaderCol[0].toString()
        } else {
            return item
        }
    }

    selectCursor(item): string {
        if (item == null) {
            return 'cursorDefault'
        } else if (item.indexOf('|') > -1) {
            this.HeaderCol = item.split('|')
            switch (this.HeaderCol.length) {
                case 3:
                    if (
                        this.HeaderCol[2].toString() == 'Y' &&
                        this.HeaderCol[0].length > 0
                    ) {
                        return 'cursorPointer textUnderline'
                    }
                    break

                case 5:
                    if (
                        this.HeaderCol[2].toString() == 'Y' &&
                        this.HeaderCol[0].length > 0
                    ) {
                        return 'cursorPointer textUnderline'
                    }
                    break

                default:
                    return 'cursorDefault'
            }
        } else {
            return 'cursorDefault'
        }
    }

    setSeverity(item): string {
        if (item == null) {
            return 'secondary'
        } else if (item.indexOf('|') > -1) {
            this.HeaderCol = item.split('|')
            if (
                this.HeaderCol[1] != null &&
                this.HeaderCol[1].toString() != '' &&
                this.HeaderCol[1].toString() + '' != ''
            ) {
                var Flag = this.HeaderCol[1].toString().toUpperCase()

                if (
                    Flag == 'HIGH' ||
                    Flag == 'H' ||
                    Flag == 'A' ||
                    Flag == 'BH' ||
                    Flag == 'HH' ||
                    Flag == 'PH'
                ) {
                    this.LinkStyle = 'color:black;display:block'
                    return 'p-badge p-badge-danger ' + this.selectCursor(item)
                }

                if (
                    Flag == 'LOW' ||
                    Flag == 'L' ||
                    Flag == 'BL' ||
                    Flag == 'LL' ||
                    Flag == 'PL'
                ) {
                    this.LinkStyle = 'color:#F7F3F3;display:block'
                    return 'p-badge p-badge-info ' + this.selectCursor(item)
                }
                if (Flag == 'N') {
                    this.LinkStyle = 'color:black;display:block'
                    return ''
                }
            }
        }
    }

    Getfield(item) {
        if (item == null) {
            return ''
        }
        if (item.indexOf('NOT') > -1) {
            return 'NA'
        }
        if (item.indexOf('|') > -1) {
            this.HeaderCol = item.split('|')

            return this.HeaderCol[0].toString()
        } else {
            return item
        }
    }

    getCategories() {

        return this.allCategories.filter(i => {

           return this.summaryViewData.filter(j => JSON.stringify(j).indexOf(i.testName) != -1).length > 0


        })
    }
    viewImage(image: Image) {
        this.pdf = null;
         this.getdocumnetdetails(image).subscribe((documentDetails) => {


             if (documentDetails.errorMessage) {
                 this.messageService.add({
                     key: 'alertToast',
                     severity: 'error',
                     summary: 'ERROR',
                     detail:
                         'Document File missing, Please Contact Technical Support',
                 })
                 this.pdf = null;
                 return;


             }

            if (documentDetails.flexPaper) {
              
                            this.pdf= documentDetails.documentBlob,
                     
                    this.showPrintButton = CareFinitySession?.user.roles.patientRecordsPrint && CareFinitySession.practiceSettings.enablePatientDemographicPrint;
                this.enabledDocumentDownloads = CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user.roles.enableDocumentDownloads


                       

            } else {
                const binaryData = [documentDetails.documentBlob]
                const downloadLink = document.createElement('a')
                downloadLink.href = window.URL.createObjectURL(
                    new Blob(binaryData, { type: documentDetails.documentBlob.type }),
                )
                downloadLink.target = '_blank'
                downloadLink.setAttribute('inline', 'arshid')
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink) // Clean up
            }
         }, err => {
             this.pdf = null;
         })
}

    getdocumnetdetails(obj) {
        this.pdf = null;

        const user=  JSON.parse(localStorage.getItem('currentUser'))

        return this.imageService
            .imageDetail({
                DocumentType: obj.documentType,
                InDataBase: obj.inDataBase,
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),

                Id: obj.documentID,
                FileType: obj.fileType,
                UserId: CareFinitySession.user.userID.toString(),
            })
            .pipe(
                map((imgDetails) => ({ ...obj, ...imgDetails })),

                mergeMap((docementDetails: ImageModels) => {
                    if (docementDetails.errorMessage) {
                        return of({ ...docementDetails, documentBlob: new Blob() })
                    }

                    return this.docservice
                        .documentGetDocuments({
                            fn: docementDetails.selectedPDF,
                            PatientName: sessionStorage.getItem('ptName'),
                        })
                        .pipe(mergeMap((i) => of({ ...docementDetails, documentBlob: i })))
                }),
            )
    }
    getTitle(key) {
        if (!key) return "";
       return this.preferences[key.toLowerCase()] || key

    }


    getBMIStyle(bmi: number): any {
        if (bmi == null || isNaN(bmi) || bmi == 0) {
            return { color: 'gray', fontWeight: 'bold' };
        }

        if (bmi < 18.5) {
            return { color: 'blue', fontWeight: 'bold' }; // Underweight
        } else if (bmi <= 24.9) {
            return { color: 'green', fontWeight: 'bold' }; // Normal
        } else if (bmi <= 29.9) {
            return { color: 'orange', fontWeight: 'bold' }; // Overweight
        } else {
            return { color: 'red', fontWeight: 'bold' }; // Obese
        }
    }

}

const groupBy = <T, K extends keyof any>(arr: T[], key: (i: T) => K) =>
    arr.reduce((groups, item) => {
        (groups[key(item)] ||= []).push(item);
        return groups;
    }, {} as Record<K, T[]>);

function flattenArray(arr) {
    return arr.reduce((acc, val) =>
        Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val), []);
}


